import React from "react";

function AppFormError({ children }) {
  if (!children) return null;

  return <h6 className="app-auth-form-error">{children}</h6>;
}

export default AppFormError;
